'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthBitHeader = require('@narvar/nth-bit-header');
var TelephoneInput = require('@narvar/nth-block-telephone-input');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var Button = require('@narvar/nth-block-button');
var Box = require('../../../../../../../common/components/layout/Box/Box.js');
var Typography = require('../../../../../../../common/components/Typography.js');
var TextLink = require('@narvar/nth-bit-text-link');
var nthHookTheme = require('@narvar/nth-hook-theme');
var OTPProvider = require('../OTPProvider.js');
var ErrorBanner = require('../../../../../../../common/components/ErrorBanner.js');
var useTitanAnalytics = require('../../../../../../../common/providers/titan/useTitanAnalytics.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var TelephoneInput__default = /*#__PURE__*/_interopDefaultLegacy(TelephoneInput);
var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button);
var TextLink__default = /*#__PURE__*/_interopDefaultLegacy(TextLink);

const OTPSendToNewPhone = () => {
  const titan = useTitanAnalytics["default"]();
  const {
    claimsOtpDisclaimer,
    claimsOtpSendToNewPhoneTitle,
    claimsOtpSendToNewPhoneDescription,
    claimsOtpSendCode,
    claimsOtpSendCodeError,
    claimsOtpSendToNewPhoneInputPlaceholder,
    claimsOtpUnableToReceiveCodeAction,
    claimsOtpUnableToReceiveCodePrompt
  } = nthHookTranslations.useTranslations();
  const {
    otpSendToNewPhone,
    handleSkipOtpNavigate,
    state: {
      otpSendLoading,
      otpSendError
    }
  } = OTPProvider.useOTP();
  const {
    linksNoneDefault: linkStyle,
    linksNoneHover: linkHoverStyle
  } = nthHookTheme.useTheme();
  const [phone, setPhone] = React.useState('');
  const submitDisabled = otpSendLoading || phone.length < 10;
  React.useEffect(() => {
    // Note: This effect is only called on first component render
    titan === null || titan === void 0 ? void 0 : titan.page({
      name: 'OTP Send - New Phone'
    })
    // eslint-disable-next-line no-console
    .catch(e => console.error(e));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React__default["default"].createElement(Box["default"], {
    gap: 4
  }, otpSendError && /*#__PURE__*/React__default["default"].createElement(ErrorBanner["default"], null, claimsOtpSendCodeError), /*#__PURE__*/React__default["default"].createElement(nthBitHeader.SemibigHeader, {
    as: "h1"
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    id: "sendToNewTitle"
  }, claimsOtpSendToNewPhoneTitle)), /*#__PURE__*/React__default["default"].createElement(Typography.BodyTextDefault, null, claimsOtpSendToNewPhoneDescription), /*#__PURE__*/React__default["default"].createElement("form", {
    noValidate: true,
    onSubmit: e => {
      e.preventDefault();
      // eslint-disable-next-line no-console
      otpSendToNewPhone(phone).catch(e => console.log(e));
    }
  }, /*#__PURE__*/React__default["default"].createElement(Box["default"], {
    gap: 4
  }, /*#__PURE__*/React__default["default"].createElement(TelephoneInput__default["default"], {
    ariaLabelledby: "sendToNewTitle",
    error: false,
    placeholder: claimsOtpSendToNewPhoneInputPlaceholder ?? undefined,
    onChangeCallback: phone => setPhone(phone)
  }), /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
    big: true,
    disabled: submitDisabled,
    type: Button.ButtonType.submit
  }, claimsOtpSendCode))), /*#__PURE__*/React__default["default"].createElement(Typography.BodyTextDefault, null, claimsOtpUnableToReceiveCodePrompt, ` `, /*#__PURE__*/React__default["default"].createElement(TextLink__default["default"], {
    onClick: handleSkipOtpNavigate,
    linkStyle: {
      sDefault: {
        ...linkStyle,
        fontSize: 'inherit'
      },
      sHover: {
        ...linkHoverStyle,
        fontSize: 'inherit'
      }
    }
  }, claimsOtpUnableToReceiveCodeAction)), /*#__PURE__*/React__default["default"].createElement(Typography.CaptionTextDefault, null, claimsOtpDisclaimer));
};
var OTPSendToNewPhone$1 = nthHookTranslations.withTranslationsProvider(nthHookTheme.withThemeProvider(OTPSendToNewPhone, {
  themeTokens: ['linksNoneDefault', 'linksNoneHover']
}), {
  translationKeys: ['claimsOtpDisclaimer', 'claimsOtpSendToNewPhoneTitle', 'claimsOtpSendToNewPhoneDescription', 'claimsOtpSendToNewPhoneInputPlaceholder', 'claimsOtpSendCode', 'claimsOtpSendCodeError', 'claimsOtpUnableToReceiveCodeAction', 'claimsOtpUnableToReceiveCodePrompt']
});

exports["default"] = OTPSendToNewPhone$1;
